import { Text, Img, Heading, Button } from "./..";
import React, { useEffect, useState } from "react";
import {API_DOMAIN_IMG, API_DOMAIN} from 'config';
import axios from "axios";
import { useNavigate } from "react-router-dom";
import { Switch } from "../../components";

import ApproveOfferByProviderPopup from "components/ApproveOfferByProviderPopup"
const COLS = [
 // { key: "rate",     title: "דירוג",            w: "12%"  },
  { key: "date",     title: "מועד ההצעה",       w: "15%" },
 /* { key: "city",     title: "מיקום",            w: "10%"  },*/
  { key: "reserved", title: "שוריין / לא",      w: "15%" },
  { key: "pickup",   title: "איסוף",            w: "12%"  },
  { key: "payEnd",   title: "סיום תשלום",       w: "15%" },
  { key: "price",    title: "מחיר",             w: "15%"  },
  { key: "action",   title: "צפייה בהצעה",      w: "15%" },
    { key: "actionSeeCar",   title: "צפייה ברכב",            w: "12%"  },

];
const statusMap = {
  0: { txt: "ממתין להצעה",  clr: "#808080cc" },
  1: { txt: "ממתין לאישור", clr: "#CE0000"   },
  2: { txt: "מאושר",       clr: "#619D1C"   },
  3: { txt: "הצעה שנדחתה",     clr: "#666666"   },
};


export default function OffersDealerTable({
  offer, 
  offers,
  onOfferApproved,
  car,
  r,
  updateShowApprovedOfferPopup,
  setSelectedOffer,
  setSelectedCar,
  onOfferClick = null, // New prop to handle offer click
...props

 // UShowApprovedOfferPopup
}) {   
  
  const { txt, clr } = statusMap[offer.offer_status];
  const navigate = useNavigate();

  const [showApprovedOfferPopuop, setShowApprovedOfferPopup] = useState(false);
// פונקציה חדשה לעיצוב תאריך
const fmt = (d) => {
  if (!d) return "";
  const date = new Date(d);
  const day = String(date.getDate()).padStart(2, '0');
  const month = String(date.getMonth() + 1).padStart(2, '0');  // חודשים מתחילים מ-0
  const year = String(date.getFullYear()).slice(-2);           // 4 ספרות → 2 ספרות
  return `${day}/${month}/${year}`;
};
const handleClick = () => {
  if (onOfferClick) {
    onOfferClick(props);   // props כבר מכיל offer_id
  } 
};
  useEffect(()=>{
  },[])
   const template = COLS?.map(c => c.w).join(" ");

   const handlePopupClose=()=>{
    setShowApprovedOfferPopup(false);
   }
   const approveOffer = async (offer) => {
    try {
      await axios.post(`${API_DOMAIN}/offer/approveOfferByProvider`, {
        offer_id: Number(offer.id),
      });

      // מעדכן את ההורה שיסיר את ההצעה
      onOfferApproved(car?.id, offer?.id);

      // הצגת פופאפ
      setSelectedOffer(offer);
      setSelectedCar(car);
      updateShowApprovedOfferPopup(true);

    } catch (err) {
      console.error(err);
      alert("אירעה שגיאה באישור ההצעה");
    }
  };
  

   const handleApproveClick = (car) => {
    //debugger;
    setSelectedCar(car);
    setShowApprovedOfferPopup(true);
  };
// פונקציה להמרת תאריכים לפורמט DD.MM.YY
const handleCarClick = () => {
 // debugger;
  if (car?.car_id) {
    navigate(`/dealer-cars/${car.car_id}`);
  }
};


  return (

    <div
      className="offer-row"
    >
  
 

      <div className="mt-2 flex w-full flex-col gap-2.5 self-end">
      <div style={{backgroundColor: '#F5F5F5'}} className="flex items-center justify-between bg-[#F5F5F5] rounded-lg p-4">
  {/* מיקום המודעה - צד ימין */}
  <div className="flex items-center text-red-a700_03 text-[16px] font-semibold">




{!(offer.offer_status == "2" || offer.offer_status == "3") &&
  <div className="mb-1.5 flex flex-1 px-2">
  <Button
    size="lg"
    shape="round"
    style={{backgroundColor: '#EFEFEF'}}
    className="offer-rank-badge min-w-[124px] gap-2 rounded-[16px] px-[12px] font-semibold !text-red-a700_03"
  >
    מיקום ההצעה: {offer.offer_position}
    <div className="flex h-[20px] w-[20px] justify-center">
      <Img src="/images/ad-place.svg" alt="Arrow Left" />
    </div>
  </Button>
</div>
}

<div className="mb-1.5 flex flex-1 px-2">
  <Button
    size="lg"
    shape="round"
    style={{backgroundColor: clr, color: 'white'}}
    className="min-w-[124px] gap-2 rounded-[16px] px-[12px] font-semibold !text-white"
  >
   {txt}

  </Button>
</div>

<div className="mb-1.5 flex flex-1 px-2">
  <Button
    size="lg"
    shape="round"
    style={{backgroundColor: 'white'}}
    className="min-w-[124px] gap-2 rounded-[16px] px-[12px] font-semibold bg-white text-black"
    >
                      {Number(offer?.sale_type_id) === 1 ? "פירוק" : "שיקום"}
                      <div className="flex h-[30px] w-[30px] justify-center">
      <Img src={
                offer.sale_type_id === "1"
                  ? "/images/total.svg"
                  : "/images/img_television_red_a700_03_2.svg"
              }              />
    </div>
  </Button>
</div>

  </div>

  {/* שנה - צד שמאל */}

  <div className="flex flex-1 items-center justify-end gap-4">
    <Text size="text4xl" as="p" className="text-[22px] font-normal lg:text-[18px]">
      {offer?.year}
    </Text>
    <div className="h-[8px] w-[8px] rounded-full bg-red-a700_03" />
    <Text size="text4xl" as="p" className="text-[22px] font-normal lg:text-[18px]">
     {offer?.manufacturer}
    </Text>
    <Heading
      size="heading12xl"
      as="h3"
      className="text-[30px] font-bold !font-heebo !text-black-900 lg:text-[25px] md:text-[24px] sm:text-[22px]"
    >
      {offer?.model}  {offer?.manufacturer}
    </Heading>
  </div>
</div>





        
        <div className="flex items-start gap-[38px] md:ml-0 md:flex-col">
          <div className="w-[80%]">
            <div className="flex justify-center md:mx-0 md:flex-col">
            
            
            <div dir="rtl" className="w-full overflow-x-auto">
      {/* HEADER */}
      <div
        className="grid min-w-[860px] items-center bg-white sticky top-0 z-10"
        style={{ gridTemplateColumns: template }}
      >
{COLS?.map((c, index) => (
  <div 
    key={c.key} 
    className="flex items-center justify-center py-2 text-sm font-assistant font-bold relative gap-2"
  >

    <span>{c.title}</span>
    {c.key !== "star" && (
      <div style={{ width: '8px' }}>
        <img src="/images/img_vector_red_a700_03_9.svg" alt="up-arrow" className="mb-0.5" />
        <img src="/images/img_vector_red_a700_03_10.svg" alt="down-arrow" className="mt-0.5" />
      </div>
    )}

  </div>
))}

      </div>

      {/* BODY */}
        <div  style={{height: '4rem', marginBottom: '0.5rem',  marginTop: '0.5rem',gridTemplateColumns: template}}
             className="grid min-w-[860px] border-none  gap-0 items-center bg-gray-50 hover:bg-gray-100  text-[15px]"
             >
              {/*
  <span className="text-center font-semibold relative">
         *****
          <div className="absolute right-0 top-0 bottom-0 w-px bg-gray-300" />
          </span>*/}
          {/* שם הקונה */}
          <span className="text-center font-semibold relative">
          {fmt(offer?.creation_date)}
          <div className="absolute right-0 top-0 bottom-0 w-px bg-gray-300" />
          </span>
          
  
          <span className="flex justify-center items-center relative">
  <Switch
    checked={!offer?.is_reserved}
    disabled={true} // אם לא רוצים שיהיה ניתן לשינוי מהטבלה
    onCheckedChange={() => {}} // פונקציה ריקה כי ה-Switch נעול
  />
  <div className="absolute right-0 top-0 bottom-0 w-px bg-gray-300" />
</span>

          
          {/* מיקום */}
        {/*  <span className="text-center relative">
           aaaaaaaaaaaa
            <div className="absolute right-0 top-0 bottom-0 w-px bg-gray-300" />
          </span>*/}
          
          {/* שוריין / לא */}
          <span className="flex justify-center relative">
          {fmt(offer?.collection_date)}

            <div className="absolute right-0 top-0 bottom-0 w-px bg-gray-300" />
          </span>
          
          {/* איסוף */}
          <span className="text-center relative">
          {fmt(offer?.last_payment_date)}

          <div className="absolute right-0 top-0 bottom-0 w-px bg-gray-300" />
          </span>
          
          {/* סיום תשלום */}
          <span className="text-center relative">
          ₪{offer?.offered_price}

          <div className="absolute right-0 top-0 bottom-0 w-px bg-gray-300" />
          </span>
          
   
          {/* אישור ההצעה */}
<div className="view-btns relative flex items-center justify-center">
          <Button
  size="lg"
  shape="round"
  style={{
    backgroundColor: 'white',
    border: '1px solid rgb(97, 157, 28)',
    color: 'rgb(97, 157, 28)',
    display: 'flex',
    alignItems: 'center',
  }}
  className="w-[124px] gap-2 rounded-[16px] px-[16px] font-semibold lg:w-[108px] lg:px-2 lg:text-[13px]"
  onClick={() => handleClick()}>
  צפייה בהצעה
  <Img 
    src="images/img_arrowleft_light_green_800_2.svg" 
    alt="Arrow" 
    className="h-[12px] w-[8px] md:h-[14px] md:w-[10px]" 
  />
</Button>
<div className="absolute right-0 top-0 bottom-0 w-px bg-gray-300" />
</div>




          {/* צפייה ברכב */}
<div className="view-btns relative flex items-center justify-center">
          <Button
  size="lg"
  shape="round"
  style={{
    backgroundColor: 'white',
    border: '1px solid rgb(97, 157, 28)',
    color: 'rgb(97, 157, 28)',
    display: 'flex',
    alignItems: 'center',
  }}
  className="w-[124px] gap-2 rounded-[16px] px-[16px] font-semibold lg:w-[108px] lg:px-2 lg:text-[13px]"
  onClick={() => handleCarClick()}>
    צפייה ברכב
  <Img 
    src="images/img_arrowleft_light_green_800_2.svg" 
    alt="Arrow" 
    className="h-[12px] w-[8px] md:h-[14px] md:w-[10px]" 
  />
</Button>
<div className="absolute right-0 top-0 bottom-0 w-px bg-gray-300" />
</div>

        </div>
      
    </div>       
    
         </div>
        
          </div>


          {/*תמונה*/}
          <div className="mt-5 flex w-[20%] justify-center rounded-md md:w-full">
            <div className="w-full rounded-md">
            <div
  className="flex h-[184px] items-start rounded-[10px] bg-cover bg-no-repeat px-6 py-[22px] lg:h-auto md:h-auto sm:p-4"
  style={{
    height:'21vh',
    objectFit: 'contain',
    backgroundImage: `url(${offer?.images[0]?.image_url ? API_DOMAIN + "/" + offer?.images[0]?.image_url: '/images/img_car11_qgcqjcnfp_428x738.png'})`
  }}
>
          
              </div>
            </div>
          </div>
        </div>
      </div>

    </div>
  );
}
